<template>
  <div>
    <div class="splc_container">
      <div class="bottom_container">
        <div class="bottom_title">
          <div class="title">
            <img src="../../assets/img/bgsp/crksqsp.png" alt="" srcset="">
          </div>
          <div class="main_lc">
            <el-timeline>
              <el-timeline-item
                v-if="dataobj[0]"
                icon="el-icon-time"
                size="large"
              >
                <div style="margin-top: 2px">
                  <span style="font-weight: bold">申请时间：</span><span>{{ dataobj[0].clsj }}</span>
                </div>
              </el-timeline-item>
              <el-timeline-item
                v-for="(item, index) in dataobj"
                :key="index"
                :icon="item.icon"
                :type="item.type"
                :size="item.size"
              >
                <div
                  style="display: flex; align-items: center; flex-wrap: wrap"
                >
                  <div style="margin-right: 20px">
                    <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
                  </div>
                  <div
                    v-if="item.sftyLabel != '待审批'"
                    style="margin-right: 20px"
                  >
                    <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
                  </div>
                  <div style="margin-right: 20px">
                    <span style="font-weight: bold">审批结果：</span><span :style="'color: ' + item.color">{{
                      item.sftyLabel
                    }}</span>
                  </div>
                  <div
                    v-if="item.sftyLabel != '待审批'"
                    style="margin-right: 20px"
                  >
                    <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
                  </div>
                </div>
                <div v-if="item.sftyLabel != '待审批'" style="margin-top: 2px">
                  <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataobj: []
    }
  }
}
</script>

<style lang="less" scoped>
.splc_container {
  .bottom_title {
    margin-top: 50px;
  }
  .main_lc {
    margin-top: 50px;
    //height: 400px;
    // background-color: darksalmon;
  }
  /deep/.el-timeline {
    padding-left: 0;
  }
  /deep/.el-timeline-item__icon {
    font-size: 16px !important;
    color: #fff;
    background-color: #ef9a12;
    border-radius: 50%;
  }

  /deep/.el-icon-success {
    color: #6acd18;
    background-color: #fff;
  }
}
</style>
